import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import ds from 'designsystem';
import { Row } from 'hedron';

import { TwoColumnGrid as TwoColumnGridModel } from 'models';
import Container from 'blocks/Container/Container';
import ColumnBlock from 'kentico-blocks/TwoColumnGrid/Column';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';

const TwoColumnGrid = styled.div`
  display: flex;
  padding: ${ds.get('metrics.base')} 0;
`;

const TwoColumnGridBlock = ({ data: { columns, htmlModifiers } }) => (
  <HTMLModifiableBackground
    htmlModifiers={htmlModifiers}
  >
    <Container>
      <TwoColumnGrid>

        <Row
          alignItems="flex-start"
        >
          {columns.map((column, index) => (column ? (
            <ColumnBlock
              data={column}
              key={column.id}
              id={index}
              lgShift={index % 2}
            />
          ) : ''))}
        </Row>

      </TwoColumnGrid>
    </Container>
  </HTMLModifiableBackground>
);

TwoColumnGridBlock.propTypes = {
  data: PropTypes.instanceOf(TwoColumnGridModel).isRequired,
};

export default TwoColumnGridBlock;



// WEBPACK FOOTER //
// ./src/kentico-blocks/TwoColumnGrid/index.jsx